import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import goods from './modules/goods'
import video from './modules/video'
import media from './modules/media'
import qrcode from './modules/qrcode'
import getters from './getters'
import {getClassifyList,editGoodsClassify,addGoodsClassify} from '@/api/api'

const store = new Vuex.Store({
	  modules: {
    goods,
    video,
    media,
    qrcode,
  },
	state:{
		pages:[
		{title:'模块',icon:'block'},{title:'控件',icon:'widget'},{title:'页面',icon:'page'}
		],
		pageon:0,
		htmlon:1,
		wxappid:'',
		showEditGoodsClassify:false,
		goodsClassifyStore:[],
		goodsClassifyForm:{
			title:'',
			img_url:'',
			parent_id:'',
			success:""
		},
	},
	mutations: {
		pageonChange (state,n) {
			state.pageon = n
		},
		editGoodsClassify(state,paramete){
			this.commit('getGoodsClassify')
			if(paramete.action=="add"){
				state.goodsClassifyForm={
					title:'',
					img_url:'',
					parent_id:'',
					success:""
				}
			}
			else{
				state.goodsClassifyForm={
					classify_id:paramete.action.id,
					title:paramete.action.title,
					img_url:paramete.action.img_url,
					parent_id:paramete.action.parent_id
				}
				console.log(paramete)
			}
			state.goodsClassifyForm.parent_id = paramete.pid;
			state.goodsClassifyForm.success = paramete.success;
			state.showEditGoodsClassify = true

		},
		hideeditGoodsClassify(state){
			state.showEditGoodsClassify=false
		},
		editGoodsClassifySuccess(state){
			console.log(state.goodsClassifyForm)
			if(state.goodsClassifyForm.classify_id){
				editGoodsClassify(state.goodsClassifyForm,window.vuevm,res=>{
					window.vuevm.$message({
						type:'success',
						message:res.data.msg
					})
					state.goodsClassifyForm.success()
					state.showEditGoodsClassify = false;
				})

			}
			else{
				addGoodsClassify(state.goodsClassifyForm,window.vuevm,res=>{
					window.vuevm.$message({
						type:'success',
						message:res.data.msg
					})
					state.goodsClassifyForm.success()
					state.showEditGoodsClassify = false;
				})
			}

			// editGoodsClassify({})
		},
		getGoodsClassify(state,fn){
			getClassifyList(window.vm,res=>{
				state.goodsClassifyStore = res.data.list;
				if(fn){
					fn(res.data.list)
				}
			})
		},
		wxappidChange(state,id){
			state.wxappid=id
		}
	},
	getters,
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js